import page from 'page'
import React from 'react'
import { isEmpty } from 'lodash'
import plural from 'smart-plurals'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

import {
  getFullInfo,
  getSimilar,
  subscribe,
  setFromList,
  sendExternalBidNotify
} from '../store/reducers/lots/single.js'
import { getLoggedUser } from '../selectors/user.js'
import { getLotName, getSimilarLots, getLotInfo, getLastBidValue } from '../selectors/lots.js'

import Comments from './Comments'
import MainContainer from './Main'
import SingleList from './LotList/singleList'
import BidOverlay from '../components/Lot/Bid'
import { get as getFeedback, send as sendFeedback } from '../store/reducers/feedback'
import { fetchingState } from './../helpers/hocs.js'
import CloseButton from './../components/CloseButton'
import BidHistory from '../components/Lot/BidHistory'

import {sendViewCard, sendViewLot, sendAddToCart, sendCheckout, sendRequestTM} from './../helpers/tagManager'

import PaymentPage from './Pay'

import Overlay from '../components/Overlay'
import Checkbox from './../components/Checkbox'

import Sidebar from './../components/Lot/Sidebar'
import PhoneConfirm from '../components/PhoneConfirm'

import numeral from 'numeral'
import * as _ from 'recompose'
import { SigninOverlay } from '../components/Lot/SigninOverlay'

import { handleActions, createAction } from 'redux-actions'
import {API_CONST} from "../store/middlewares/api";
import {getUser, openExternalLot} from "../store/reducers/auth";

const pluralize = plural.Plurals.getRule('ru')

const lastBidHeader = value => <span><FormattedMessage id='lot.last_bid' /><br /><nobr>{value}</nobr></span>
let count = 1

const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

const LotPage = ({ data = {}, bids = [], similar = [], name, closeBidOverlay, bidId, lastBid, bidLength, id, user, subscribe, setBidOverlay,
  bidOverlay, setBidLength, onBidAdd, currentLocale, intl, test, submitApplication, success = null, showPhonePopup = false, setShowPhonePopup,
  setSuccess, sendApplication, fromListNameLocal, signinOverlay, setSigninOverlay, closeSigninOverlay, sendExternalBidNotify }) => {
  if (!data || isEmpty(data)) return null
  if(!data.payCount){
    data.payCount = 0;
  }
  const isUserBid = bids.filter(el => el.targetId === user._id).length > 0
  const onClickSetBid = () => {
    if (data.isExternalLot) {
      if (!user) {
        setSigninOverlay(true)
      } else {
        window.open(data.externalLotLink, '_blank')
        sendExternalBidNotify(data._id)
      }
    } else {
      sendAddToCart({...data, name}, fromListNameLocal, count)
      setBidOverlay(true)
    }
  }

  let Button =
    <button className='Button Button_black' onClick={onClickSetBid}>
      {data.isExternalLot ? (
        intl.formatMessage({id: 'fixedlot.place_order_external'})
      ) : (
        intl.formatMessage({id: data.isVisit ? 'fixedlot.place_visit' : 'fixedlot.place_order'})
      )}
    </button>
  if (data.status !== 'active') Button = null
  //Не даем возможность купить лот если их продано столько же или больше сколкьо приобретено
  // - upd - предлагаем оставить заявку
  const onClickSendRequest = () => {
    sendAddToCart({...data, name}, fromListNameLocal, 1)
    submitApplication()
  }
  if (data.count <= data.payCount) {
    Button =
    <button className='Button Button_black' onClick={onClickSendRequest}>
      {intl.formatMessage({id: 'fixedlot.send_request'})}
    </button>
}
//присвоение значения количества покупки переменной для передачи в модалку оплаты
  /*function handleInputChange(event) {
	const target = event.target;
	target.value = target.value.replace (/[^0-9]/g, '')
	count = target.value;
  }*/

  function stepDownCount(event) {
	event.target.nextElementSibling.stepDown()
	count = event.target.nextElementSibling.value;
  }

  function stepUpCount(event) {
	event.target.previousElementSibling.stepUp()
	count = event.target.previousElementSibling.value;
  }
  let alias = data.fund._id
  if (data.fund.alias) alias = data.fund.alias
  return (
    success ? <div className='Contacts-form__title Head Message-body'>
      <CloseButton className='modal__close-button Message-close' onClick={()=>setSuccess(null)}/>
        <FormattedMessage id='fixedlot.request_sent' />
      </div>
        : (<MainContainer
      sidebarClass='Sidebar_person'
      Sidebar={<Sidebar data={{ ...data, name }} image={data.image} person={data.persons} meta={data.meta || {}} />}
    >
      <Helmet>
        <title>{data.meta.title}</title>
        <meta name='description' content={data.meta.description} />
        <meta property='og:title' content={data.meta.title} />
        <meta property='og:image' content={data.meta.image} />
        <meta property='og:url' content={window.location.href} />
        <meta property='og:description' content={data.meta.description} />
      </Helmet>

      {(data.notForSale == false) && <div className='SubHead Comments__title'>
        <FormattedMessage id={`${data.isExternalLot ? 'lot.fixed_price_external' : 'lot.fixed_price'}`} />
      </div>}
      {(data.notForSale == false) &&
      <div className='Head Comments__title'>
         {numeral(data.price).format('0,0')} {data.currency.symbol}
      </div>}
      {!data.isExternalLot && (data.notForSale == false) &&
      <div className='Text'>
        {data.isVisit
          ?
          <FormattedMessage id='lot.leftVisit' />
          :
          <FormattedMessage id='lot.left' />//Выводит количество оставшихся лотов, если осталось меньше, чем куплено, то изменяет вывод на 0
        } {(data.count>data.payCount) ? (data.count - data.payCount) : (0)}
      </div>}
      {(data.notForSale == true) &&
      <div className='Head Comments__title'>
        {data.priceRUB != null ? `${numeral(data.priceRUB).format('0,0')} ${data.currency.symbol}` : ''} <br></br>
        {data.priceUSD != null ? `${numeral(data.priceUSD).format('0,0')} USD` : ''}<br></br>
        {data.priceEUR != null ? `${numeral(data.priceEUR).format('0,0')} EUR` : ''}<br></br>
      </div>
      }
        {Button}

  {(!data.isExternalLot && data.count > data.payCount) && <div className='Text'>
    {
      data.isVisit
        ?
        <FormattedMessage id='bidPayment.count_bay_fixprice_visits' />
        :
        <FormattedMessage id='bidPayment.count_bay_fixprice' />
    }
	   <button type="button" onClick={stepDownCount} className='Button_black Button_UpDownCount'>-</button>
	   <input
	     className='CountFixPrice'
	     type='number'
	     min='1'
		 value='1'
		 disabled
       //Ставит ограничение на максимальное количество лотов, если количество купленных превосходит количество оставшихся, изменяет значение на 0
	     max={(data.count>data.payCount) ? (data.count - data.payCount) : (0)}
	     //onChange={handleInputChange}
	   />
	   <button type="button" onClick={stepUpCount} className='Button_black Button_UpDownCount'>+</button>
	  </div>}
    {
      <div className='Main__description Text'>
        <div dangerouslySetInnerHTML={{ __html: data.description }} />
        {!data.isExternalLot &&
          (data.fund._id != "5b30b97a7a86d3354a414b50" &&
            (<FormattedMessage id='lot.moneySentTo' />) ||
            (<FormattedMessage id='lot.moneySentToMFC' />))}
        {!data.isExternalLot && (
          <span style={{ color: 'red' }}>
            <a href={data.fund._id !== '5b30b97a7a86d3354a414b50' ? '/funds/' + alias : '/aboutus'}>
              {` ${data.fund.name}`}
            </a>
          </span>)}
      </div>
    }
      {!data.description && <div style={{ marginTop: 60 }} />}

      <SingleList items={similar} title={intl.formatMessage({id: 'lot.you_might'})} listName={'ФиксЛот: Вас могут заинтересовать'}/>

{/*
      <Overlay isActive={bidOverlay} onClose={closeBidOverlay}>
	<PaymentPage id={id} on404={this.handle404} />
      </Overlay>
*/}

      <Overlay isActive={bidOverlay} onClose={closeBidOverlay}>
        <BidOverlay id={id} bidId={bidId} count={count} data={{bidValue: data.price,}} onSuccess={onBidAdd} isSubscribed={data.isSubscribed} title={data.meta.title} />
      </Overlay>

        <Overlay isActive={signinOverlay} onClose={closeSigninOverlay}>
          <SigninOverlay />
        </Overlay>

      <Overlay isActive={showPhonePopup} onClose={()=> setShowPhonePopup(false)} klassModifier='is--blured'>
        <PhoneConfirm onClose={()=> setShowPhonePopup(false)} submit={sendApplication}/>
      </Overlay>

    </MainContainer>)
  )
}

const mapStateToProps = state => ({
  data: getLotInfo(state),
  similar: getSimilarLots(state),
  bids: state.lots.single.bids,
  bidMessage: state.lots.single.bidMessage,
  name: getLotName(state),
  lastBid: getLastBidValue(state),
  user: getLoggedUser(state),
  person: state.feedback.info,
  fromListName: state.lots.single.fromListName
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getFullInfo,
  getSimilar,
  subscribe,
  getFeedback,
  sendFeedback,
  setFromList,
  sendExternalBidNotify
}, dispatch)

const mergeProps = (state, dispatch, props) => ({
  ...props,
  ...state,
  getFullInfo: async (id) => {
    id = id || props.id
    if (!id) return
    let result = await dispatch.getFullInfo(id, {typelot:'fixedpricelot'})
    if (result === 200) await dispatch.getSimilar(id)
    else props.on404()
  },
  onBidAdd: async (id) => {
    id = id || props.id
    if (!id) return
    let result = await dispatch.getFullInfo(id, { noRewrite: true })
    if (result === 200) {
      props.setBidOverlay(false)
	  //различный адрес колбэка для фиксированных лотов и Помощи, прописано в этом компаненте так как на него возвращается из рбкмани
	  if(id !== 'help'){
        page(`/fixedpricelots/${id}`)
	  }
	  else{
	    page(`/help`)
	  }
    }
  },
  subscribe: async flag => {
    if (!props.id || !state.data) return
    await dispatch.subscribe(props.id, !state.data.isSubscribed)
  },
  getFeedback: async () => {
    let result = await dispatch.getFeedback()
  },
  sendFeedback: (data) => {
    return(props.fetchingWrap(dispatch.sendFeedback.bind(this, data), 'send'))
  },
  clearFromList: async () => {
    dispatch.setFromList(null)
  },
  sendExternalBidNotify: async (id) => {
    await dispatch.sendExternalBidNotify(id)
  }
})

export default injectIntl(compose(
  withState('bidLength', 'setBidLength', 5),
  withState('bidOverlay', 'setBidOverlay', null),
  withState('signinOverlay', 'setSigninOverlay', null),
  withState('success', 'setSuccess', null),
  withState('showPhonePopup', 'setShowPhonePopup', false),
  withState('fromListNameLocal', 'setFromListNameLocal', ""),
  fetchingState({ multi: true }),
  connect(mapStateToProps, mapDispatchToProps, mergeProps, state => ({currentLocale: state.intl.locale})),
  withHandlers({
    //отправка заявки на лот
    sendApplication: ({person, sendFeedback, data, setSuccess, name, setShowPhonePopup}) => async (phone, e) => {
      e && e.preventDefault()
      //if (person.name && phone) {
        if(phone){
        setSuccess(null)
        const requestData = {
          contact: phone,
          message: "Заявка на фиксированный лот: " + name +" (" + data._id + ") от " + person.name,
          name: person.name? person.name : phone,
          topic: "fixedpricelot"
        }
        const result = await sendFeedback(requestData)
        setShowPhonePopup(false)
        setSuccess(result === 200);
        if (result === 200) {
          sendRequestTM({...data, name}, 1);
        }
      }
    },
    setBidOverlay: ({ setBidOverlay }) => (flag, e) => {
      e && e.preventDefault()
      setBidOverlay(flag)
    },
    setBidLength: ({ setBidLength }) => (num, e) => {
      e && e.preventDefault()
      setBidLength(num)
    },
    closeBidOverlay: ({ id, bidId, setBidOverlay }) => e => {
		count = 1
      e && e.preventDefault()
      setBidOverlay(false)
      if (bidId) page(`/fixedpricelots/${id}`)
    },
    //после нажатия на кнопку Оставить заявку, нужно открыть окно с подтверждением номера телефона
    submitApplication: ({person, setShowPhonePopup}) => async e => {
      e && e.preventDefault()
      //if (person.name && person.contact) {
        setShowPhonePopup(true)
      //}
    },
    setSigninOverlay: ({ setSigninOverlay }) => (flag, e) => {
      e && e.preventDefault()
      setSigninOverlay(flag)
    },
    closeSigninOverlay: ({ setSigninOverlay }) => e => {
      e && e.preventDefault()
      setSigninOverlay(false)
    }
  }),
  lifecycle({
    componentWillMount () {
      this.props.getFullInfo()
      this.props.getFeedback()
    },
    componentDidMount () {
      this.props.bidId && this.props.setBidOverlay(true)
    },
    componentDidUpdate (prevProps) {
      if (this.props.user && !prevProps.user) {
        this.props.closeSigninOverlay()
      }
    },
    componentWillReceiveProps (np) {
      if (np.bidId && (np.bidId !== this.props.bidId)) this.props.setBidOverlay(true)
      if (np.id && (np.id !== this.props.id)) this.props.getFullInfo(np.id)
      if (np.similar && np.similar.length > 0 && np.similar !== this.props.similar) sendViewCard(np.similar, 'ФиксЛот: Вас могут заинтересовать')
      if (np.data && Object.keys(np.data).length !== 0 && (np.data !== this.props.data)) {
      //отправка данных о просмотре лота
        sendViewLot({...np.data, name: np.name}, np.fromListName)
        this.props.setFromListNameLocal(np.fromListName)
        this.props.clearFromList()
      }
      //открытие окна ввода номера телефона при заявке на лот
      if (np.showPhonePopup && !this.props.showPhonePopup) {
        sendCheckout({...np.data, name: np.name}, 1)
      }
    }
  })
)(LotPage))



// WEBPACK FOOTER //
// ./src/containers/FixedPriceLot.jsx